

import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useResponsiveValue } from '@/hooks/use-responsive-value';

export function BasicIdentitySection({ isNameReadonly }: { isNameReadonly?: boolean }) {
  const { register, watch, formState: { errors } } = useFormContext();
  const resolveResponsive = useResponsiveValue();
  const { t } = useTranslation();

  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Typography variant="h2" sx={{ mb: 2 }}>
        {t('entity_form.locations.main_info_title')}
      </Typography>

      <Grid container spacing={3}>
        <Grid size={resolveResponsive({ xs: 12 })}>
          <TextField
            fullWidth
            label={t('entity_form.locations.labels.name')}
            {...register('name')}
            error={!!errors.name}
            helperText={errors.name?.message as string}
            disabled={isNameReadonly}
            required
          />
        </Grid>

        <Grid size={resolveResponsive({ xs: 12, md: 6 })}>
          <TextField
            fullWidth
            label={t('entity_form.locations.labels.type')}
            {...register('type')}
            error={!!errors.type}
            helperText={errors.type?.message as string}
            placeholder={t('entity_form.locations.labels.type_placeholder')}
          />
        </Grid>

        <Grid size={resolveResponsive({ xs: 12, md: 6 })}>
          <TextField
            fullWidth
            label={t('entity_form.locations.labels.region')}
            {...register('region')}
            error={!!errors.region}
            helperText={errors.region?.message as string}
            placeholder={t('entity_form.locations.labels.region_placeholder')}
          />
        </Grid>

        <Grid size={resolveResponsive({ xs: 12 })}>
          <TextField
            fullWidth
            multiline
            minRows={3}
            variant="filled"
            label={t('entity_form.locations.labels.short_desc')}
            {...register('shortDescription')}
            error={!!errors.shortDescription}
            helperText={errors.shortDescription?.message as string}
            placeholder={t('entity_form.locations.labels.short_desc_placeholder')}
            InputProps={{
              sx: {
                p: 1.5,
                '& textarea': { resize: 'vertical' }
              }
            }}
          />
        </Grid>

        <Grid size={resolveResponsive({ xs: 12 })}>
          <TextField
            fullWidth
            multiline
            minRows={3}
            variant="filled"
            label={t('entity_form.locations.labels.visual_description')}
            {...register('visualDescription')}
            inputProps={{ maxLength: 1500 }}
            error={!!errors.visualDescription}
            helperText={(errors.visualDescription?.message as string) || `${(watch('visualDescription') || '').length} / 1500`}
            placeholder={t('entity_form.locations.labels.visual_description_placeholder')}
            InputProps={{
              sx: {
                p: 1.5,
                '& textarea': { resize: 'vertical' }
              }
            }}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}
